import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { useMutation, useQueryClient } from "react-query";
import { RateioForm } from "../typings";

const getRoute = (id: string) => `/v1/rateio/${id}/`;
function useEditRateio(onSuccess?: (id: string) => any) {
  const queryClient = useQueryClient();

  return useMutation(
    "edit/v1/rateio/:id",
    ({ id, data }: { id: string; data: RateioForm }) =>
      http.put(getRoute(id), data),
    {
      retry: false,
      onSuccess: (_, { id }) => {
        queryClient.invalidateQueries(getRoute(id));
        queryClient.invalidateQueries("/v1/rateio");
        onSuccess?.(id);
      },
      onError: (e) => {
        showErrorAxios(e)
      }
    }
  );
}

export default useEditRateio;
